export class SoundDefinition {
  constructor(public title: string, public source: string) {}
}
